// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationFR from "./fr/translations-fr";

// the translations
const resources = { fr: { translation: translationFR } };

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    interpolation: {
      escapeValue: false // react already safes from xss
    },
    lng: "fr",
    resources
  });

export default i18n;
